export const COMPANY_HEADCOUNT_IDS: Record<string, string> = {
  "Self-employed": "A",
  "1-10": "B",
  "11-50": "C",
  "51-200": "D",
  "201-500": "E",
  "501-1,000": "F",
  "1,001-5,000": "G",
  "5,001-10,000": "H",
  "10,001+": "I",
};

export const getCompanyHeadCountId = (name: string): string | undefined => {
  const id = COMPANY_HEADCOUNT_IDS[name.trim()];
  if (!id) {
    console.log(`ℹ️  No LinkedIn ID found for company headcount: "${name}" - using text search fallback`);
  }
  return id;
};

export const COMPANY_TYPE_IDS: Record<string, string> = {
  "Public Company": "C",
  "Privately Held": "P",
  "Self Employed": "E",
  "Non Profit": "N",
  "Educational Institution": "D",
  "Partnership": "S",
  "Self Owned": "O",
  "Government Agency": "G",
  "College Page": "A",
};

export const getCompanyTypeId = (name: string): string | undefined => {
  const id = COMPANY_TYPE_IDS[name.trim()];
  if (!id) {
    console.log(`ℹ️  No LinkedIn ID found for company type: "${name}" - using text search fallback`);
  }
  return id;
};
